import React from "react";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'

export default function HistoryLogBasicInfo(props) {
    const { historyLog } = props;

    const logInfo = { ...historyLog };
    delete logInfo.details;

    return (
        <Card>
            <CardHeader color="info">
                <h4>Info</h4>
            </CardHeader>
            <CardBody sx={{ maxHeight: "470px" }}>
                <JsonView src={logInfo} />
            </CardBody>
        </Card>
    );
}
